import React from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import PendingStatementsFailPage from './PendingStatementsFailPage';

const PendingStatementsFailSection = ({ bankId }) => <PendingStatementsFailPage bankId={bankId} />;

PendingStatementsFailSection.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: selectors.bankId(state)
});

export default connect(mapStateToProps, null)(PendingStatementsFailSection);
